import UniswapIcon from './UniswapIcon'

export default UniswapIcon
